module.exports = __webpack_public_path__ + "img/menu_settings.b7295661.svg";